<!--
  name : 김장호
  desc : 
  date : 2020-07-08
-->
<template>
  <v-app id="bgSt">
    <v-row no-gutters align="center" id="top_bar">
      <v-toolbar-title class="top_bar_logo" @click="goMain"
        >로고</v-toolbar-title
      >
      <v-row no-gutters class="top_bar_nonLayO justfy-end align-center">
        <v-btn class="btn_top_bar btnTBhome" @click="goMain"
          ><span class="icon"></span>서비스 소개</v-btn
        >
      </v-row>
    </v-row>
    <router-view class="conWguest"></router-view>
  </v-app>
</template>
<script>
export default {
  name: "guestLayout",
  components: {},
  filters: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    goMain() {
      this.$router.push({ name: "main" });
    }
  }
};
</script>
<style scoped></style>
